import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgJobPerTemplateIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="job_per_template_svg__nc-icon-wrapper">
      <path d="M23 18H1v40a2 2 0 0 0 2 2h20V18zM8 26h6a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm0 6h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm0 6h6a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm0 6h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm6 8H8a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zM25 18v42h36a2 2 0 0 0 2-2V18H25zm14 14h8a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2zm-6-6h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2zm6 26h-6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zm8-6h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm8-6H44a1 1 0 1 1 0-2h11a1 1 0 1 1 0 2z" />
      <path
        data-color="color-2"
        d="M61 4H3a2 2 0 0 0-2 2v10h62V6a2 2 0 0 0-2-2zM7 12a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 12zm7 0a2 2 0 1 1-.001-3.999A2 2 0 0 1 14 12zm7 0a2 2 0 1 1-.001-3.999A2 2 0 0 1 21 12z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgJobPerTemplateStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgJobPerTemplateIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const JobPerTemplateIcon: any = SvgJobPerTemplateStyle;
export default JobPerTemplateIcon;
